"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3724],{

/***/ 89010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73680);
/* harmony import */ var _wallet_adapter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33618);



const isCommitment = (value)=>typeof value === "string";
const useConfirmTransaction = ()=>{
    const { connection  } = (0,_wallet_adapter__WEBPACK_IMPORTED_MODULE_2__/* .useConnection */ .Rc)();
    const confirmTransaction = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async function(txSignature) {
        let commitmentOrLatestBlockhash = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "finalized";
        const latestBlockhash = isCommitment(commitmentOrLatestBlockhash) ? await connection.getLatestBlockhash(commitmentOrLatestBlockhash) : commitmentOrLatestBlockhash;
        const [, confirmation] = await (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__/* .toResultAsync */ .zM)(connection.confirmTransaction({
            signature: txSignature,
            ...latestBlockhash
        }));
        const error = !confirmation || confirmation.value.err;
        return [
            error,
            confirmation
        ];
    }, [
        connection
    ]);
    return {
        confirmTransaction
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useConfirmTransaction);


/***/ }),

/***/ 96769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ isMarketSupportedToken; }
/* harmony export */ });
/* harmony import */ var _orca_so_common_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66259);
/* harmony import */ var _orca_so_common_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_orca_so_common_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _renec_foundation_escrow_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32626);
/* harmony import */ var _renec_foundation_escrow_sdk__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_renec_foundation_escrow_sdk__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _solana_web3_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27632);
/* harmony import */ var decimal_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90482);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88767);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1880);
/* harmony import */ var _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28309);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73680);
/* harmony import */ var _use_escrow_ctx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6698);










// TODO: get from settings instead of hardcode
const tokens = (0,_constants_index__WEBPACK_IMPORTED_MODULE_6__/* .isChainSolana */ .j2)() ? [
    "reUSD"
] : [
    "reVND",
    "reUSD",
    "reNGN"
];
const isMarketSupportedToken = (token)=>tokens.includes(token);
const tokensMintAddress = {
    reVND: _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_7__/* .REVND_MINT_ADDRESS */ .PW,
    reUSD: _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_7__/* .REUSD_MINT_ADDRESS */ .Df,
    reNGN: _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_7__/* .RENGN_MINT_ADDRESS */ .f_
};
const BONDLESS_MAX_AMOUNT_LIMIT_IN_USD = 3;
const useMarketClient = ()=>{
    const { context , configId , programId  } = (0,_use_escrow_ctx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    const { renecTokenInfo  } = (0,_hooks_use_tokens__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Co)();
    const { data: marketClientMap  } = (0,react_query__WEBPACK_IMPORTED_MODULE_5__.useQuery)({
        queryKey: [
            "marketClientMap",
            configId,
            programId
        ],
        queryFn: async ()=>{
            const [, marketDatas] = await (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_8__/* .toResultAsync */ .zM)(Promise.all(tokens.map((token)=>{
                return _renec_foundation_escrow_sdk__WEBPACK_IMPORTED_MODULE_1__.MarketClient.getMarket(context, configId, configId, new _solana_web3_js__WEBPACK_IMPORTED_MODULE_2__.PublicKey(tokensMintAddress[token]))// eslint-disable-next-line no-console
                .catch(console.error);
            })));
            return (marketDatas || []).reduce((acc, marketData, idx)=>{
                acc[tokens[idx]] = marketData;
                return acc;
            }, {});
        },
        enabled: !!context,
        refetchInterval: 10000,
        initialData: {}
    });
    const getMarketData = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((tokenSymbol)=>{
        var _marketClientMap_tokenSymbol;
        const data = marketClientMap === null || marketClientMap === void 0 ? void 0 : (_marketClientMap_tokenSymbol = marketClientMap[tokenSymbol]) === null || _marketClientMap_tokenSymbol === void 0 ? void 0 : _marketClientMap_tokenSymbol.data;
        if (data) {
            const minimumOfferSize = _orca_so_common_sdk__WEBPACK_IMPORTED_MODULE_0__.DecimalUtil.fromU64(data.minimumOfferSize, data.tokenDecimals);
            const bondlessLimitAmount = _orca_so_common_sdk__WEBPACK_IMPORTED_MODULE_0__.DecimalUtil.adjustDecimals(new decimal_js__WEBPACK_IMPORTED_MODULE_3__/* .Decimal */ .t(BONDLESS_MAX_AMOUNT_LIMIT_IN_USD).mul(data.tokenMetadata.usdRate.toNumber()), data.expo).toDP(data.tokenDecimals, decimal_js__WEBPACK_IMPORTED_MODULE_3__/* .Decimal.ROUND_DOWN */ .t.ROUND_DOWN);
            return {
                minimumOfferSize,
                bondlessLimitAmount,
                penaltyNativeBondIncrement: _orca_so_common_sdk__WEBPACK_IMPORTED_MODULE_0__.DecimalUtil.fromU64(data.penaltyNativeBondIncrement, renecTokenInfo.decimals)
            };
        }
    }, [
        marketClientMap,
        renecTokenInfo
    ]);
    return {
        marketClientMap,
        getMarketData
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useMarketClient);


/***/ }),

/***/ 77798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _orca_so_common_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66259);
/* harmony import */ var _orca_so_common_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_orca_so_common_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1880);
/* harmony import */ var _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28309);
/* harmony import */ var _utils_apis_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35108);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73680);
/* harmony import */ var _utils_numeric__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14847);








const useNotifyToInternalTeam = ()=>{
    const { fiatTokensMap , fiatCustomInfoList  } = (0,_hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Co)();
    const sendNotice = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((params)=>{
        const { txid , category , tradeOrderData: { tradeId , pubkey , tokenMint , tradeAmount: tokenAmount , fiatAmount , sellerBondType , buyerBondType , buyerAuthority , sellerAuthority , createdAt , sellOfferId , buyOfferId , fiatCurrency  }  } = params;
        const tokenInfo = fiatTokensMap.get(tokenMint.toBase58());
        const formattedCryptoAmount = "".concat((0,_utils_numeric__WEBPACK_IMPORTED_MODULE_7__/* .format */ .WU)(_orca_so_common_sdk__WEBPACK_IMPORTED_MODULE_0__.DecimalUtil.fromU64(tokenAmount, tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.decimals), tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.decimals), " ").concat(tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.symbol);
        const fiatInfo = fiatCustomInfoList.find((t)=>{
            var _t_displaySymbol;
            return ((_t_displaySymbol = t.displaySymbol) === null || _t_displaySymbol === void 0 ? void 0 : _t_displaySymbol.toLowerCase()) === fiatCurrency.toLowerCase();
        });
        const formattedFiatAmount = "".concat((0,_utils_numeric__WEBPACK_IMPORTED_MODULE_7__/* .format */ .WU)(fiatAmount, fiatInfo === null || fiatInfo === void 0 ? void 0 : fiatInfo.decimals), " ").concat(fiatCurrency);
        const buyerAddress = buyerAuthority.toBase58();
        const tradeDetails = [
            "*Trade detail:*",
            ...sellOfferId ? [
                "Sell Offer ID: #".concat(sellOfferId === null || sellOfferId === void 0 ? void 0 : sellOfferId.toNumber())
            ] : [],
            ...buyOfferId ? [
                "Buy Offer ID: #".concat(buyOfferId === null || buyOfferId === void 0 ? void 0 : buyOfferId.toNumber())
            ] : [],
            "Sell *`".concat(formattedCryptoAmount, "`* for *`").concat(formattedFiatAmount, "`*"),
            "Bond type of seller: ".concat(Object.keys(sellerBondType)[0]),
            "Seller address: ".concat(sellerAuthority.toBase58()),
            ...buyerAddress !== "11111111111111111111111111111111" ? [
                "Buyer address: ".concat(buyerAddress),
                "Bond type of buyer: ".concat(Object.keys(buyerBondType)[0])
            ] : [],
            "Created at: ".concat(moment__WEBPACK_IMPORTED_MODULE_1___default()(createdAt.muln(1000).toNumber()).format(_constants_index__WEBPACK_IMPORTED_MODULE_3__/* .TRADE_DATE_FORMAT */ .e6))
        ];
        const notificationPayload = {
            blocks: [
                {
                    type: "header",
                    text: {
                        type: "plain_text",
                        text: "[".concat(category, "] trade #").concat(tradeId.toString())
                    }
                },
                {
                    type: "section",
                    fields: [
                        {
                            type: "mrkdwn",
                            text: tradeDetails.join("\n• ")
                        }
                    ]
                },
                ...pubkey ? [
                    {
                        type: "section",
                        fields: [
                            {
                                type: "mrkdwn",
                                text: "<".concat((0,_utils_helpers__WEBPACK_IMPORTED_MODULE_6__/* .getAddressUrl */ .$U)(pubkey.toBase58()), "|View detail on Explorer>")
                            }
                        ]
                    }
                ] : [],
                {
                    type: "section",
                    fields: [
                        {
                            type: "mrkdwn",
                            text: "<".concat((0,_utils_helpers__WEBPACK_IMPORTED_MODULE_6__/* .getTransactionDetailUrl */ .$P)(txid), "|View TX on Explorer>")
                        }
                    ]
                }
            ]
        };
        (0,_utils_apis_helper__WEBPACK_IMPORTED_MODULE_5__/* .notify */ .h4)(notificationPayload);
    }, [
        fiatTokensMap,
        fiatCustomInfoList
    ]);
    const sendOfferNotice = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((params)=>{
        const { txid , category , offerData: { offerId , pubkey , tokenMint , totalAmount , bondType , makerAuthority , createdAt , fiatCurrency , rate  }  } = params;
        const tokenInfo = fiatTokensMap.get(tokenMint.toBase58());
        const formattedCryptoAmount = "".concat((0,_utils_numeric__WEBPACK_IMPORTED_MODULE_7__/* .format */ .WU)(_orca_so_common_sdk__WEBPACK_IMPORTED_MODULE_0__.DecimalUtil.fromU64(totalAmount, tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.decimals), tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.decimals), " ").concat(tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.symbol);
        const fiatAmount = totalAmount.muln(rate);
        const formattedFiatAmount = "".concat((0,_utils_numeric__WEBPACK_IMPORTED_MODULE_7__/* .format */ .WU)(_orca_so_common_sdk__WEBPACK_IMPORTED_MODULE_0__.DecimalUtil.fromU64(fiatAmount, tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.decimals), tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.decimals), " ").concat(fiatCurrency);
        const offerDetails = [
            "*Offer detail:*",
            "Sell *`".concat(formattedCryptoAmount, "`* for *`").concat(formattedFiatAmount, "`*"),
            "Bond type: ".concat(Object.keys(bondType)[0]),
            "Seller address: ".concat(makerAuthority.toBase58()),
            "created at: ".concat(moment__WEBPACK_IMPORTED_MODULE_1___default()(createdAt.muln(1000).toNumber()).format(_constants_index__WEBPACK_IMPORTED_MODULE_3__/* .TRADE_DATE_FORMAT */ .e6))
        ];
        const notificationPayload = {
            blocks: [
                {
                    type: "header",
                    text: {
                        type: "plain_text",
                        text: "[".concat(category, "] offer #").concat(offerId.toString())
                    }
                },
                {
                    type: "section",
                    fields: [
                        {
                            type: "mrkdwn",
                            text: offerDetails.join("\n• ")
                        }
                    ]
                },
                ...pubkey ? [
                    {
                        type: "section",
                        fields: [
                            {
                                type: "mrkdwn",
                                text: "<".concat((0,_utils_helpers__WEBPACK_IMPORTED_MODULE_6__/* .getAddressUrl */ .$U)(pubkey.toBase58()), "|View offer detail on Explorer>")
                            }
                        ]
                    }
                ] : [],
                ...txid ? [
                    {
                        type: "section",
                        fields: [
                            {
                                type: "mrkdwn",
                                text: "<".concat((0,_utils_helpers__WEBPACK_IMPORTED_MODULE_6__/* .getTransactionDetailUrl */ .$P)(txid), "|View TX on Explorer>")
                            }
                        ]
                    }
                ] : []
            ]
        };
        (0,_utils_apis_helper__WEBPACK_IMPORTED_MODULE_5__/* .notify */ .h4)(notificationPayload);
    }, [
        fiatTokensMap
    ]);
    return {
        sendNotice,
        sendOfferNotice
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useNotifyToInternalTeam);


/***/ }),

/***/ 76243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_safely_send_tx_with_notice; }
});

// UNUSED EXPORTS: isKnownError

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(1880);
// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(73680);
// EXTERNAL MODULE: ./src/wallet/adapter.ts + 1 modules
var adapter = __webpack_require__(33618);
// EXTERNAL MODULE: ./src/hooks/use-confirmation-transaction.ts
var use_confirmation_transaction = __webpack_require__(89010);
// EXTERNAL MODULE: ./node_modules/@solana/web3.js/lib/index.browser.esm.js + 3 modules
var index_browser_esm = __webpack_require__(27632);
;// CONCATENATED MODULE: ./src/hooks/use-gasless-handling.ts




const useGaslessHandling = ()=>{
    const { connection  } = (0,adapter/* useConnection */.Rc)();
    const { wallet , publicKey  } = (0,adapter/* useWallet */.Os)();
    return (0,react.useCallback)(async (tx)=>{
        if ((0,constants/* isChainSolana */.j2)()) return await tx.buildAndExecute();
        const { instructions , cleanupInstructions , signers  } = tx.compressIx(true);
        const transaction = new index_browser_esm.Transaction();
        for (const ix of instructions){
            transaction.add(ix);
        }
        for (const cIx of cleanupInstructions){
            transaction.add(cIx);
        }
        transaction.feePayer = publicKey !== null && publicKey !== void 0 ? publicKey : undefined;
        transaction.recentBlockhash = (await connection.getLatestBlockhash()).blockhash;
        for (const s of signers){
            transaction.sign(s);
        }
        return await (wallet === null || wallet === void 0 ? void 0 : wallet.adapter).sendTransactionWithSigners(transaction, connection, signers);
    }, [
        connection,
        wallet,
        publicKey
    ]);
};
/* harmony default export */ var use_gasless_handling = (useGaslessHandling);

// EXTERNAL MODULE: ./src/hooks/use-settings.ts + 1 modules
var use_settings = __webpack_require__(49472);
// EXTERNAL MODULE: ./src/hooks/use-toast-message.tsx + 1 modules
var use_toast_message = __webpack_require__(36625);
// EXTERNAL MODULE: ./src/hooks/useTrans.ts + 2 modules
var useTrans = __webpack_require__(74069);
;// CONCATENATED MODULE: ./src/hooks/use-safely-send-tx-with-notice.tsx











const KnownErrorTesters = {
    "0x1": [
        /Attempt to debit an account but found no record of a prior credit/,
        /custom program error: 0x1$/
    ],
    "wallet_refused": [
        /^refuse_send_transaction$/,
        /^user denied transaction signature$/,
        /^user denied sign transactions$/,
        /^WalletSignTransactionError$/,
        /^WalletSignTransactionError: Transaction rejected$/,
        /^WalletSignTransactionError: User rejected the request\.$/
    ]
};
const isKnownError = (error)=>{
    var _Object_entries_find;
    return (_Object_entries_find = Object.entries(KnownErrorTesters).find((param)=>{
        let [, testers] = param;
        return testers.some((tester)=>tester.test(error.message) || tester.test(String(error)));
    })) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[0];
};
const useSafelySendTxWithNotice = function() {
    let globalContextOrOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const globalOptions = (0,react.useMemo)(()=>typeof globalContextOrOptions === "string" ? {
            context: globalContextOrOptions
        } : globalContextOrOptions, [
        globalContextOrOptions
    ]);
    const { connection  } = (0,adapter/* useConnection */.Rc)();
    const { confirmTransaction  } = (0,use_confirmation_transaction/* default */.Z)();
    const { showMessage , showLoadingNotice  } = (0,use_toast_message/* default */.Z)();
    const trans = (0,useTrans/* default */.Z)();
    const { data: settingsData  } = (0,use_settings/* useSettings */.r)();
    const gaslessEnabled = Boolean(settingsData === null || settingsData === void 0 ? void 0 : settingsData.is_gasless_mode_enabled);
    const sendTxWithGasless = use_gasless_handling();
    var _globalOptions_alwaysHideTxExplorerLink, _globalOptions_confirmationErrorMessage, _globalOptions_confirmationErrorTitle, _ref, _globalOptions_context, _globalOptions_errorMessage, _globalOptions_errorTitle, _globalOptions_gasless, _globalOptions_onBeforeShowingNotice, _globalOptions_successMessage, _globalOptions_successTitle, _globalOptions_throwOnError, _globalOptions_waitUntilConfirmed;
    const safelySendTxWithNotice = (0,react.useCallback)(/**
     * @throws never, unless `throwOnError` is set to `true`.
     */ async function(tx) {
        let { alwaysHideTxExplorerLink =(_globalOptions_alwaysHideTxExplorerLink = globalOptions.alwaysHideTxExplorerLink) !== null && _globalOptions_alwaysHideTxExplorerLink !== void 0 ? _globalOptions_alwaysHideTxExplorerLink : false , confirmationErrorMessage =(_globalOptions_confirmationErrorMessage = globalOptions.confirmationErrorMessage) !== null && _globalOptions_confirmationErrorMessage !== void 0 ? _globalOptions_confirmationErrorMessage : trans.common.tx_notice.unconfirmed_message , confirmationErrorTitle =(_ref = (_globalOptions_confirmationErrorTitle = globalOptions.confirmationErrorTitle) !== null && _globalOptions_confirmationErrorTitle !== void 0 ? _globalOptions_confirmationErrorTitle : globalOptions.errorTitle) !== null && _ref !== void 0 ? _ref : trans.common.tx_notice.error_title , context =(_globalOptions_context = globalOptions.context) !== null && _globalOptions_context !== void 0 ? _globalOptions_context : "common" , errorMessage =(_globalOptions_errorMessage = globalOptions.errorMessage) !== null && _globalOptions_errorMessage !== void 0 ? _globalOptions_errorMessage : trans.common.tx_notice.error_message , errorTitle =(_globalOptions_errorTitle = globalOptions.errorTitle) !== null && _globalOptions_errorTitle !== void 0 ? _globalOptions_errorTitle : trans.common.tx_notice.error_title , gasless =(_globalOptions_gasless = globalOptions.gasless) !== null && _globalOptions_gasless !== void 0 ? _globalOptions_gasless : gaslessEnabled , onBeforeShowingNotice =(_globalOptions_onBeforeShowingNotice = globalOptions.onBeforeShowingNotice) !== null && _globalOptions_onBeforeShowingNotice !== void 0 ? _globalOptions_onBeforeShowingNotice : ()=>true , primaryButton =globalOptions.primaryButton , snackbarOptions =globalOptions.snackbarOptions , successMessage =(_globalOptions_successMessage = globalOptions.successMessage) !== null && _globalOptions_successMessage !== void 0 ? _globalOptions_successMessage : trans.common.tx_notice.success_message , successTitle =(_globalOptions_successTitle = globalOptions.successTitle) !== null && _globalOptions_successTitle !== void 0 ? _globalOptions_successTitle : trans.common.tx_notice.success_title , throwOnError =(_globalOptions_throwOnError = globalOptions.throwOnError) !== null && _globalOptions_throwOnError !== void 0 ? _globalOptions_throwOnError : false , titleAppendix =globalOptions.titleAppendix , waitUntilConfirmed =(_globalOptions_waitUntilConfirmed = globalOptions.waitUntilConfirmed) !== null && _globalOptions_waitUntilConfirmed !== void 0 ? _globalOptions_waitUntilConfirmed : true  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const noticeElement = function(e) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return typeof e === "function" ? e(...args) : e;
        };
        const [error, signature] = await (0,helpers/* toResultAsync */.zM)("then" in tx ? tx : gasless && !(0,constants/* isChainSolana */.j2)() ? sendTxWithGasless(tx) : tx.buildAndExecute());
        if (error) {
            var _isKnownError;
            const errorKey = (_isKnownError = isKnownError(error)) !== null && _isKnownError !== void 0 ? _isKnownError : "unknown";
            const errorTroubleshootingByContext = trans.common.tx_notice.errors[errorKey];
            var _errorTroubleshootingByContext_common;
            const troubleshooting = [
                ...(_errorTroubleshootingByContext_common = errorTroubleshootingByContext === null || errorTroubleshootingByContext === void 0 ? void 0 : errorTroubleshootingByContext.common) !== null && _errorTroubleshootingByContext_common !== void 0 ? _errorTroubleshootingByContext_common : []
            ];
            if (context !== "common" && (errorTroubleshootingByContext === null || errorTroubleshootingByContext === void 0 ? void 0 : errorTroubleshootingByContext[context])) {
                troubleshooting.splice(0, 0, ...errorTroubleshootingByContext[context]);
            }
            // eslint-disable-next-line no-console
            console.error("".concat(context, " send transaction error"), error, error.logs);
            if (onBeforeShowingNotice("error", error) !== false) {
                showMessage({
                    error,
                    message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "text-sm",
                                children: noticeElement(errorMessage, error)
                            }),
                            Boolean(troubleshooting.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-xs font-bold",
                                        children: trans.common.tx_notice.what_should_i_do_now
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        spacing: 0.5,
                                        children: troubleshooting.map((solution, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                component: "li",
                                                className: "text-sm",
                                                children: solution
                                            }, index))
                                    })
                                ]
                            })
                        ]
                    }),
                    primaryButton: noticeElement(primaryButton, "error", error),
                    title: noticeElement(errorTitle, error),
                    titleAppendix: noticeElement(titleAppendix, "error", error),
                    type: "error"
                }, snackbarOptions);
            }
            if (throwOnError) throw error;
            return;
        }
        if (waitUntilConfirmed) {
            const latestBlockhash = await connection.getLatestBlockhash();
            const closeLoadingNotice = showLoadingNotice({
                lastValidBlockHeight: latestBlockhash.lastValidBlockHeight,
                signature
            });
            const [isTxConfirmed, { value: { err: confirmationError  }  }] = await confirmTransaction(signature, latestBlockhash);
            closeLoadingNotice();
            if (!isTxConfirmed && confirmationError) {
                // eslint-disable-next-line no-console
                console.error("".concat(context, " confirm transaction error"), confirmationError);
                if (onBeforeShowingNotice("confirmation_error", signature, confirmationError) !== false) {
                    showMessage({
                        message: noticeElement(confirmationErrorMessage, signature, error),
                        primaryButton: noticeElement(primaryButton, "confirmation_error", signature, error),
                        title: noticeElement(confirmationErrorTitle, signature, error),
                        titleAppendix: noticeElement(titleAppendix, "confirmation_error", signature, error),
                        type: "error",
                        txid: alwaysHideTxExplorerLink ? undefined : signature
                    }, snackbarOptions);
                }
                if (throwOnError) throw confirmationError;
                return;
            }
        }
        ;
        if (onBeforeShowingNotice("success", signature) !== false) {
            showMessage({
                message: noticeElement(successMessage, signature),
                primaryButton: noticeElement(primaryButton, "success", signature),
                title: noticeElement(successTitle, signature),
                titleAppendix: noticeElement(titleAppendix, "success", signature),
                type: "success",
                txid: alwaysHideTxExplorerLink ? undefined : signature
            }, snackbarOptions);
        }
        return signature;
    }, [
        confirmTransaction,
        connection,
        gaslessEnabled,
        globalOptions,
        sendTxWithGasless,
        showLoadingNotice,
        showMessage,
        trans
    ]);
    return {
        safelySendTxWithNotice
    };
};
/* harmony default export */ var use_safely_send_tx_with_notice = (useSafelySendTxWithNotice);


/***/ })

}]);